import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './firebase';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import AppPage from './pages/AppPage';
import ResultsPage from './pages/ResultsPage';
import PaywallPage from './pages/PaywallPage';
import HistoryPage from './pages/HistoryPage';

function App() {
  const [user, loading] = useAuthState(auth);

  if (loading) return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      background: '#0D0D1A',
      color: '#0F7DFF',
      fontFamily: 'Inter, sans-serif'
    }}>
      Loading...
    </div>
  );

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={!user ? <LoginPage /> : <Navigate to="/app" />} />
        <Route path="/app" element={<AppPage />} />
        <Route path="/results" element={<ResultsPage />} />
        <Route path="/upgrade" element={user ? <PaywallPage /> : <Navigate to="/login" />} />
        <Route path="/history" element={user ? <HistoryPage /> : <Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;